import React, { useState } from 'react'
import s from './AccuracySecurity.module.css'
import { showHtml } from '@lib/utils/utils'
import Image from "next/legacy/image"
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import { Keyboard, Mousewheel, Autoplay, Pagination } from 'swiper/modules'


export interface IListForm {
  content: string
  title: string
  icon: string
}

export interface AccuracySecurityProps {
  title?: string
  titleLineTwo?: string
  image?: any
  icon?: any
  className?: string
  list?: Array<IListForm>
  variant2?: boolean
  extraText?: string
}

const AccuracySecurity: React.FC<AccuracySecurityProps> = ((props) => {
  let {
    list,
    className,
    title,
    titleLineTwo,
    image,
    icon,
    variant2,
    extraText
  } = props

  const [showStep, setShowStep] = useState(0)
  const [swiper, setSwiper] = useState(useSwiper())

  if (list?.length === 0) {
    return null
  }

  const changeStep = function(step: any) {
    setShowStep(step.target.id)
  }

  return (
    <div className={`${s.root} ${className} accuracy_security` + ' ' + (variant2 ? '' : 'bg-primary100')}>
      <div>
        <div className={`grid grid-cols-1 lg:grid-cols-2`}>
          <div className={'h-full relative'}>
            {variant2 && <div
              className='block w-full h-full block overflow-hidden relative'>
              <Image alt='Section image' src={image} layout='fill' objectFit='cover' />
            </div>}
            {!variant2 && <div className={s.contentWrapper}>
              <ul className={s.list + ' hidden xl:block'}>
                {list && list.map((item, index) => {
                  return <li id={'accuracy_security_step_' + index}
                             className={s.item + ' ' + (showStep == index ? '' : 'hidden')} key={index}>
                    {item.icon && <div className={s.iconText}>
                      <span className={s.icon + ' ' + item.icon}></span>
                    </div>}
                    <h4 className={`${s.question} uppercase pb-2`}>
                      {item.title}
                    </h4>
                    <p className={`text-neutral900 ${s.text}`}
                       dangerouslySetInnerHTML={showHtml(item.content)} />
                    <div className={s.liner} />
                  </li>
                })}
              </ul>
              <div className={s.list + ' xl:hidden'}>
                <Swiper
                  cssMode={true}
                  slidesPerView={1}
                  navigation={false}
                  pagination={{
                    clickable: true,
                  }}
                  mousewheel={true}
                  keyboard={true}
                  loop={false}
                  scrollbar={{
                    draggable: false
                  }}
                  onSwiper={(s: any) => {
                    setSwiper(s)
                  }}
                  modules={[Mousewheel, Keyboard, Pagination]}
                  className={s.mySwiper + ' biggerDots'}
                >
                  {list && list.map((item, index) => {
                    return <SwiperSlide key={item.title + index} className={s.swiperSlide}>
                      <div id={'accuracy_security_step_' + index}
                           className={s.item + ' mb-10 xl:mb-0'} key={index}>
                        {item.icon && <div className={s.iconText}>
                          <span className={s.icon + ' ' + item.icon}></span>
                        </div>}
                        <h4 className={`${s.question} text-white`}>
                          {item.title}
                        </h4>
                        <p className={`text-paragraph03 text-neutral700 ${s.text}`}
                           dangerouslySetInnerHTML={showHtml(item.content)} />
                        <div className={s.liner} />
                      </div>
                    </SwiperSlide>
                  })}
                </Swiper>
              </div>
              <ul className={s.listLinks + ' hidden xl:block'}>
                {list && list.map((item, index) => {
                  return <li id={index.toString()} onClick={changeStep}
                             className={s.itemLink + ' itemLink ' + (showStep == index ? 'active' : 'text-neutral600')}
                             key={index}>
                    <div className={`${s.questionLink} text-paragraph02 pointer-events-none uppercase`}>
                      {item.title}
                    </div>
                  </li>
                })}
              </ul>
            </div>}
          </div>
          <div className={' ' + (variant2 ? 'h-e420 lg:h-e700 relative overflow-hidden' : s.titleCover)}>
            {image && !variant2 && <div
              className='block w-full h-full block overflow-hidden relative'>
              <Image alt='Helper image' src={image} layout='fill' objectFit='cover' />
            </div>}
            <div className={s.imageContent}>
              <div className={s.imageIcon + ' ' + icon}>
                <span className={'lg:hidden'}><Image className={s.imageIconMobileImage} alt='Mobile icon' src={icon} width={120} height={120} /></span>
                <span className={'hidden lg:block'}><Image className={s.imageIconImage} alt='Icon' src={icon} width={140} height={140} /></span>
              </div>
              <h2 className={`text-heading01Mobile md:text-heading01 font-normal ${s.title} ` + (variant2 ? 'text-neutral900' : 'text-neutral50')}>{title} <br className={'hidden md:block'} />{titleLineTwo}
              </h2>
              {variant2 && <p className={'text-paragraph02 md:mt-space20'}>{extraText}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default AccuracySecurity
